import { FC } from "react";

import { BuilderIOTabOptions, SKUPageContentTabType } from "@/data/types";

import { BuilderIOTabSettings } from "./builder-io-tab/builder-io-tab-settings";
import { CMSTab } from "./cms-tab";
import { CMSTabProvider } from "./cms-tab-context";

type Props = {
  index: number;
  options: BuilderIOTabOptions;
};

export const CMSBuilderTab: FC<Props> = ({ index, options }) => (
  <CMSTabProvider
    tabType={SKUPageContentTabType.BUILDER_IO_TAB}
    tabIndex={index}
  >
    <CMSTab options={options}>
      <BuilderIOTabSettings options={options} />
    </CMSTab>
  </CMSTabProvider>
);
